import { Controller } from "stimulus"

export default class PostEpisodePicker extends Controller {
  static targets = ["linkedPanel", "standalonePanel", "episodeIdField", "submitButton", "episodeRow"]

  connect() {
    this._selectedEpisodeId = null
    this._selectStandalone()
  }

  selectLinked() {
    this._activateLinked()
  }

  selectStandalone() {
    this._selectStandalone()
  }

  selectEpisode(event) {
    event.stopPropagation()
    const row = event.currentTarget
    const { episodeId, episodeLabel } = row.dataset
    this._selectedEpisodeId = episodeId
    this.episodeIdFieldTarget.value = episodeId
    this.submitButtonTarget.value = `Continue with ${episodeLabel}`
    this._activateLinked()
    this.episodeRowTargets.forEach(r => {
      const isSelected = r.dataset.episodeId === episodeId
      this._setRowSelected(r, isSelected)
    })
  }

  _activateLinked() {
    this.linkedPanelTarget.classList.add("border-purple-400", "bg-purple-50")
    this.linkedPanelTarget.classList.remove("border-gray-200")
    this.standalonePanelTarget.classList.remove("border-purple-400", "bg-purple-50")
    this.standalonePanelTarget.classList.add("border-gray-200")
  }

  _selectStandalone() {
    this._selectedEpisodeId = null
    this.episodeIdFieldTarget.value = ""
    this.submitButtonTarget.value = "Continue"
    this.standalonePanelTarget.classList.add("border-purple-400", "bg-purple-50")
    this.standalonePanelTarget.classList.remove("border-gray-200")
    this.linkedPanelTarget.classList.remove("border-purple-400", "bg-purple-50")
    this.linkedPanelTarget.classList.add("border-gray-200")
    this.episodeRowTargets.forEach(r => this._setRowSelected(r, false))
  }

  _setRowSelected(row, selected) {
    const radioEl = row.querySelector("[data-role='radio']")
    if (!radioEl) return
    const circle = radioEl.querySelector(".radio-circle")
    const dot = radioEl.querySelector(".radio-dot")
    if (selected) {
      circle?.classList.add("border-purple-500")
      circle?.classList.remove("border-gray-300")
      dot?.classList.remove("hidden")
    } else {
      circle?.classList.remove("border-purple-500")
      circle?.classList.add("border-gray-300")
      dot?.classList.add("hidden")
    }
  }
}
